import HomeIcon from '@mui/icons-material/Home'
// import ContentPasteOutlinedIcon from '@mui/icons-material/ContentPasteOutlined'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import BusinessIcon from '@mui/icons-material/Business'

export const sideBarValues = [
	{
		title: 'Início',
		option: 0,
		link: '/',
		icon: <HomeIcon fontSize='small' />,
	},
	{
		title: 'Folhas de Ponto',
		option: 1,
		link: '/timesheet',
		icon: <CalendarTodayIcon fontSize='small' />,
	},
	// {
	// 	title: 'Escalas',
	// 	option: 2,
	// 	link: '/schedules',
	// 	icon: <ContentPasteOutlinedIcon fontSize='small' />,
	// },
]

export const adminSideBarValues = [
	{
		title: 'Homepage',
		option: 0,
		link: '/',
		icon: <HomeIcon fontSize='small' />,
	},
	{
		title: 'Empresas',
		option: 1,
		link: '/companies',
		icon: <BusinessIcon fontSize='small' />,
	},
]
